<template>
  <v-chart
    ref="echarts"
    :option="option"
    :autoresize="true"
    class="c-chart"
    @legendselectchanged="legendselectchanged"
  />
</template>

<script>
import { use } from 'echarts/core'
import { SVGRenderer } from 'echarts/renderers'
import { LineChart } from 'echarts/charts'
import {
  GridComponent,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  DataZoomComponent,
  MarkLineComponent,
  DataZoomSliderComponent,
  DataZoomInsideComponent,
} from 'echarts/components'
import VChart, { THEME_KEY } from 'vue-echarts'

use([
  LineChart,
  SVGRenderer,
  GridComponent,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  DataZoomComponent,
  MarkLineComponent,
  DataZoomSliderComponent,
  DataZoomInsideComponent,
])

export default {
  name: 'HawaLineChart',
  components: {
    VChart,
  },
  provide: {
    [THEME_KEY]: 'light',
  },
  props: {
    Option: Object,
  },
  data() {
    return {
      option: {},
    }
  },

  methods: {
    legendselectchanged(args) {
      this.$emit('legendselectchanged', args)
    },
  },

  created() {
    this.option = { ...this.option, ...this.Option }
  },

  watch: {
    Option: {
      deep: true,
      handler: function() {
        this.$refs.echarts.clear()
        this.option = { ...this.option, ...this.Option }
      },
    },
  },
}
</script>

<style scoped lang="scss">
.c-chart {
  height: 100vh;
  max-height: calc(100vh - 450px);
  width: 100%;
}
</style>
